<!-- Copyright (c) 2020. Sonrai Analytics Ltd. -->
<!-- Developed by Deva Sen, Warren Dowey, Ryan Duffy & Gerard Loughran -->

<router-outlet></router-outlet>
